import React, { useMemo } from "react";

import clsx from "clsx";

import { useDesignElementManager } from "@hooks/use-design-element-manager";
import { PLATFORM_NORTHBEAM } from "@north-beam/nb-common";

import { type DataColumn } from "../types";

export function SpendConstraintLabel({
  dataColumn,
  size = "md",
}: {
  dataColumn: DataColumn;
  size?: string;
}) {
  const { designElementManager } = useDesignElementManager();
  const isPlatformFeature = useMemo(() => {
    if (!dataColumn.is_from_mta) {
      return false;
    } else if (dataColumn.mta_breakdowns?.[0].key === PLATFORM_NORTHBEAM) {
      return true;
    }
    return false;
  }, [dataColumn.is_from_mta, dataColumn.mta_breakdowns]);

  const renderIcon = () => {
    if (!isPlatformFeature) {
      return null;
    }

    return designElementManager
      .getDesignElement(dataColumn.mta_breakdowns?.[0]?.value ?? "")
      .getComponent({
        size: size === "md" ? "25px" : "18px",
      });
  };

  let label: any = dataColumn.friendly_name;
  const [breakdown1, breakdown2] = label.split("/");
  if (breakdown1 && breakdown2) {
    label = (
      <>
        <span className="text-gray+1">{breakdown1}</span>
        <span>/</span>
        <span>{breakdown2}</span>
      </>
    );
  }

  return (
    <div className="flex justify-start items-center gap-2">
      <span>{renderIcon()}</span>
      <span
        className={clsx({ "text-sm": size === "md", "text-xs": size === "sm" })}
      >
        {label}
      </span>
    </div>
  );
}
